"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAppendedQueryString = void 0;
/**
 * A function that allows you to generate an elastic search specific query string for a specific facet to match on a range of values.
 *
 * @param facet The facet you wish to match against
 * @param terms The specific values you wish to match against
 * @param logic Allows you to determine whether the constructed query is logically AND vs OR.
 * @returns
 */
function generateAppendedQueryString(facet, valuesToMatchOn, logic) {
    if (logic === void 0) { logic = 'OR'; }
    return "* AND " + facet + ":(" + valuesToMatchOn.reduce(function (prev, curr) { return "(" + prev + ") " + logic + " (" + curr + ")"; }) + ")";
}
exports.generateAppendedQueryString = generateAppendedQueryString;
